export default /*@ngInject*/ function () {

    const vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onInit;

    vm.next = next;
    vm.previous = previous;
    vm.updateTab = updateTab;
    vm.click = click;

    function onInit() {
        if (vm.tabs) {
            vm.tabs = vm.tabs.filter(tab => !tab.hidden);

            vm.lastTabIndex = vm.tabs.length - 1;
            vm.currentTabIndex = vm.tabs.findIndex(tab => tab.active);

            vm.currentTab = vm.tabs.find(tab => tab.active);
        }
    }

    async function updateValidSteps(tabs, keys) {
        tabs.forEach(tab => {
            if (tab.id === vm.currentTab.id) {
                tab.valid = keys.every(key => vm.comparisonKeys[key]);
            }

            return tab;
        });

        vm.currentTab = vm.tabs.find(tab => tab.active);

        return tabs;
    }

    async function click(event) {
        let tabs = vm.tabs;

        tabs = await updateValidSteps(tabs, vm.validationKeys);

        let invalidSteps = tabs.any(t => !t.valid);


        if (vm.currentTab.valid && event === 'next') {
            next(invalidSteps);
        } else if (event !== 'next') {
            updateTab(event);
        }
    }

    function updateTab(tab) {
        const tabClickedIndex = vm.tabs.findIndex(tabs => tabs.id === tab.id);

        if (vm.currentTabIndex !== tabClickedIndex) {

            if (!vm.currentTab.valid && vm.currentTabIndex > tabClickedIndex) {
                vm.tabs[vm.currentTabIndex].active = false;
                vm.currentTabIndex = tabClickedIndex;
                vm.tabs[vm.currentTabIndex].active = true;
            } else if (vm.currentTab.valid) {
                vm.tabs[vm.currentTabIndex].active = false;
                vm.currentTabIndex = tabClickedIndex;
                vm.tabs[vm.currentTabIndex].active = true;
            }

            const tabs = vm.tabs;
            vm.onNavigation({ tabs });
        }
    }

    function next(invalidSteps) {
        if (vm.currentTabIndex === vm.lastTabIndex && !invalidSteps) {
            complete();
        } else {
            vm.tabs[vm.currentTabIndex].active = false;

            if (vm.currentTabIndex < vm.lastTabIndex) {
                vm.currentTabIndex++;
            }

            vm.tabs[vm.currentTabIndex].active = true;
        }

        const tabs = vm.tabs;
        vm.onNavigation({ tabs });
    }

    function previous() {
        vm.tabs[vm.currentTabIndex].active = false;

        if (vm.currentTabIndex > 0) {
            vm.currentTabIndex--;
        }

        vm.tabs[vm.currentTabIndex].active = true;

        const tabs = vm.tabs;
        vm.onNavigation({ tabs });
    }

    function complete() {
        vm.onSave();
    }
}